<div class="d-flex justify-content-center p-5">
  <div class="card shadow rounded-0 border-0 avs-user-settings">
    <!-- Grey title row like the table header of the overview pages. -->
    <div class="d-flex justify-content-between align-items-center bg-light avs-dialog-header ps-4 pe-3">
      <ng-container *ngIf="userId; else newUser">
        <h6 class="mb-0">Benutzer Einstellungen</h6>
      </ng-container>
      <ng-template #newUser>
        <h6 class="mb-0">Benutzer hinzufügen</h6>
      </ng-template>
      <div class="avs-arrow-left" (click)="onBackIconClicked()">
        <img class="p-1" src="assets/icons/arrow-left.svg">
        <span class="me-2">zurück</span>
      </div>
    </div>

    <div class="p-3">
    <div class="mb-3">
      <div class="row">
        <div class="col-sm-6 col-md-4 mb-2">
          <avs-text-input [value]="userData ? userData.title : ''"
            (valueChange)="onCompanyDataValueChange($event, UserDataTypes.title)" [required]="false" placeholder="Titel">
          </avs-text-input>
        </div>
        <div class="col-sm-6 col-md-4 mb-2">
          <avs-text-input [value]="userData ? userData.firstName : ''"
            (valueChange)="onCompanyDataValueChange($event, UserDataTypes.firstName)" [required]="true"
            [classInputOnly]="missingClass(userData.firstName)" placeholder="Vorname">
          </avs-text-input>
        </div>
        <div class="col-md-4 mb-2">
          <avs-text-input [value]="userData ? userData.lastName : ''"
            (valueChange)="onCompanyDataValueChange($event, UserDataTypes.lastName)" [required]="true"
            [classInputOnly]="missingClass(userData.lastName)" placeholder="Nachname">
          </avs-text-input>
        </div>
      </div>

      <div class="mt-4">
        <avs-text-input [value]="userData ? userData.email : ''"
          (valueChange)="onCompanyDataValueChange($event, UserDataTypes.email)" [required]="true"
          [classInputOnly]="missingClass(userData.email)" placeholder="E-Mail">
        </avs-text-input>
      </div>

      <div class="row mt-4">
        <div class="col-md-6 mb-4">
          <p>Institution auswählen</p>
          <div class="avs-user-dropdown-container position-relative">
            <div [ngClass]="isCompanyDropdownOpen || missingClass(userData.company) ? 'border-danger' : ''" class="border d-flex justify-content-between"
              role="button" (click)="onCompanyDropdownClicked()">

              <ng-container *ngIf="userId">
                <div class="ms-2 p-1">{{ selectedCompany ? selectedCompany.name : 'Keine Institution hinterlegt' }}
                </div>
              </ng-container>
              <ng-container *ngIf="!userId">
                <div class="ms-2 p-1">{{ selectedCompany ? selectedCompany.name : 'Institution auswählen' }}</div>
              </ng-container>

              <img *ngIf="!isCompanyDropdownOpen" class="me-2" src="assets/icons/caret-down.svg"
                alt="caret-down open select">
              <img *ngIf="isCompanyDropdownOpen" class="me-2" src="assets/icons/caret-up.svg"
                alt="caret-up close select">
            </div>
            <avs-dropdown [selectInput]="companySelectInput" [activeItem]="selectedCompany"
              (onItemClicked)="onCompanyDropdownValueChange($event)" [isHeaderActive]="false"
              *ngIf="isCompanyDropdownOpen" class="position-absolute avs-user-dropdown-container">
            </avs-dropdown>
          </div>
        </div>
        <div class="col-md-6">
          <p>Rolle auswählen</p>
          <div class="avs-user-dropdown-container position-relative">
            <div [ngClass]="isRoleDropdownOpen ? 'border-danger' : ''" class="border d-flex justify-content-between"
              role="button" (click)="onRoleDropdownClicked()">
              <div class="ms-2 p-1">{{ selectedRole ? selectedRole.name : 'Rolle auswählen' }}</div>
              <img *ngIf="!isRoleDropdownOpen" class="me-2" src="assets/icons/caret-down.svg"
                alt="caret-down open select">
              <img *ngIf="isRoleDropdownOpen" class="me-2" src="assets/icons/caret-up.svg" alt="caret-up close select">
            </div>
            <avs-dropdown [selectInput]="roleSelectInput" [activeItem]="selectedRole ? selectedRole : undefined"
              (onItemClicked)="onRoleDropdownValueChange($event)" [isHeaderActive]="false" *ngIf="isRoleDropdownOpen"
              class="position-absolute avs-user-dropdown-container">
            </avs-dropdown>
          </div>
        </div>
      </div>
      <!-- Authorizations and "2FA required" are part of CreateRequest as well, so they are shown in both modes. -->
      <div class="mt-4">
        <div class="row">
          <div class="col-md-6 mb-2">
            <mat-slide-toggle [(ngModel)]="userData.isAuthorizedForDownloads">Berechtigung zum Download:
              {{ userData.isAuthorizedForDownloads ? 'Ja' : 'Nein' }}</mat-slide-toggle>
          </div>
          <div class="col-md-6 mb-2">
            <mat-slide-toggle [(ngModel)]="userData.isAuthorizedForAlarms">Berechtigung für Alarme:
              {{ userData.isAuthorizedForAlarms ? 'Ja' : 'Nein' }}</mat-slide-toggle>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <div class="row">
          <div class="col-md-6 mb-2">
            <mat-slide-toggle
              [ngModel]="userData.isTwoFactorRequired"
              (ngModelChange)="onTwoFactorRequiredChange($event)"
              [disabled]="isTwoFactorRequirementLocked">
              2FA verpflichtend: {{ userData.isTwoFactorRequired ? 'Ja' : 'Nein' }}
            </mat-slide-toggle>
            <div class="small text-secondary mt-2">
              <ng-container *ngIf="isTwoFactorRequirementLocked">
                Die aktuelle 2FA-Policy verlangt 2FA für dieses Konto.
              </ng-container>
              <ng-container *ngIf="!isTwoFactorRequirementLocked">
                {{ userData.isTwoFactorRequired
                  ? 'Der Benutzer muss 2FA nutzen und kann sie nicht selbst deaktivieren.'
                  : 'Aktivieren, um den Benutzer zu zwingen, 2FA beim nächsten Anmelden einzurichten, bevor er das Portal benutzen kann.' }}
              </ng-container>
            </div>
          </div>
          <!-- Suspending 2FA only makes sense for an existing account. -->
          <div class="col-md-6 mb-2" *ngIf="userId">
            <mat-slide-toggle
              [ngModel]="suspend2FA"
              (ngModelChange)="onTwoFactorSuspend($event)"
              [disabled]="!hasUserTwoFactorEnabled">
              2FA einmalig aussetzen: {{ suspend2FA ? 'Ja' : 'Nein' }}
            </mat-slide-toggle>
            <div class="small text-secondary mt-2">
              <ng-container *ngIf="!hasUserTwoFactorEnabled">
                2FA für dieses Konto nicht aktiviert.
              </ng-container>
              <ng-container *ngIf="hasUserTwoFactorEnabled">
                {{ suspend2FA
                  ? 'Aktuell genutzte 2FA des Benutzers wird zurückgesetzt, damit dieser 2FA beim nächsten Anmelden neu aufsetzen kann.'
                  : 'Aktivieren, um dem Benutzer zu erlauben, 2FA beim nächsten Anmelden neu einzurichten.' }}
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <!-- Edit mode only: the admin can set a password for the user. Normally the user sets it via the
           emailed link, so the inputs are collapsed by default. -->
      <ng-container *ngIf="userId">
        <div class="mt-4">
          <div class="d-flex align-items-center" role="button" (click)="onPasswordSectionToggleClicked()">
            <img class="me-2" [src]="isPasswordSectionOpen ? 'assets/icons/caret-down.svg' : 'assets/icons/caret-right.svg'"
              [alt]="isPasswordSectionOpen ? 'Passwortfelder einklappen' : 'Passwortfelder ausklappen'">
            <span>Passwort neu setzen</span>
          </div>
          <div class="row mt-2" *ngIf="isPasswordSectionOpen">
            <div class="col-md-6 mb-2">
              <avs-password-confirm-input [required]="false" (passwordChange)="onNewPasswordChange($event)">
              </avs-password-confirm-input>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="mt-4" *ngIf="userId">
        <ng-container *ngIf="originalAcceptTerms; else noConsent">
          <mat-slide-toggle
            [ngModel]="resetAcceptTerms"
            (ngModelChange)="onResetAcceptTermsChange($event)">
            Datenschutz-Zustimmung zurücksetzen: {{ resetAcceptTerms ? 'Ja' : 'Nein' }}
          </mat-slide-toggle>
          <div class="small text-secondary mt-2">
            Setzt die erteilte Zustimmung zurück; der Benutzer muss beim nächsten Login erneut zustimmen.
            Eine Zustimmung kann nur der Benutzer selbst erteilen.
          </div>
        </ng-container>
        <ng-template #noConsent>
          <div class="small text-secondary">
            Datenschutz-Zustimmung: Nicht erteilt (kann nur der Benutzer selbst erteilen).
          </div>
        </ng-template>
      </div>

      <div class="text-end" *ngIf="isCardChanged">
        <button class="btn btn-outline-success rounded-0 mt-4 avs-test-area-save-btn m-2" type="button"
          (click)="onSaveCardBtnClicked()">
          Speichern
        </button>
      </div>
      <div *ngIf="userId">
        <div class="d-flex justify-content-between">
          <p>Zugewiesene Projekte</p>
          <img (click)="onAddProjectBtnClicked()" class="avs-icon-add mb-3" src="assets/icons/plus.svg"
            alt="icon-add-group">
        </div>
        <div class="card border-1 rounded-0">
          <div *ngFor="let project of assignedProjects">
            <div class="d-flex border-bottom border-1 m-2">
              <span class="fw-semibold">{{ project.name }}</span>
              <img (click)="onDeleteBtnClicked(project.id)" class="ms-2 avs-icon-delete" src="assets/icons/trash.svg" alt="icon-delete-group">
            </div>

            <div *ngFor="let group of project.groups; let i = index" [ngClass]="i % 2 === 0 ? 'bglg' : ''">
              <div class="d-flex justify-content-between" [ngClass]="i === project.groups.length - 1 ? 'big-bottom-border' : ''">
                <div class="ms-4">{{ group.name }}</div>

                <section class="example-section" style="margin-right: 20px;">
                  <mat-checkbox [ngModel]="group.userGroupErrorTypeChannelError"
                    (ngModelChange)="changeUserGroupErrorTypeChannel(group.id, group)">
                    Kanalfehler</mat-checkbox>
                  <mat-checkbox [ngModel]="group.userGroupErrorTypePixelError"
                    (ngModelChange)="changeUserGroupErrorTypePixel(group.id, group)">
                    Pixel Fehler</mat-checkbox>
                  <mat-checkbox (ngModelChange)="changeUserGroupErrorTypeVoltage(group.id, group)"
                    [ngModel]="group.userGroupErrorTypeVoltageError">Spannungsfehler</mat-checkbox>
                  <mat-checkbox [ngModel]="group.userGroupErrorTypeFuelWarning"
                    (ngModelChange)="changeUserGroupErrorTypeFuelWarning(group.id, group)">
                    Kraftstoffwarnung</mat-checkbox>
                  <mat-checkbox [ngModel]="group.userGroupErrorTypeSystemStatusFuelcell"
                    (ngModelChange)="changeUserGroupErrorTypeSystemStatusFuelcell(group.id, group)">
                    Systemstatus Brennstoffzelle</mat-checkbox>
                  <mat-checkbox [ngModel]="group.userGroupErrorTypeSTMInput"
                    (ngModelChange)="changeUserGroupErrorTypeSTMInput(group.id, group)">
                    Digital IO</mat-checkbox>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>
